import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import WhatsAppFab from "@/components/WhatsAppFab";

export default function Layout() {
  const location = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  return (
    <SmoothScroll>
      <div className="grain-overlay min-h-screen bg-vorna-bg text-white">
        <Navbar />
        <main><Outlet /></main>
        <Footer />
        <WhatsAppFab />
      </div>
    </SmoothScroll>
  );
}
